export enum TelemedicineFlowEnum {
    welcome = 1,
    patientIdentification = 2,
    emergencyCheck = 3,
    preEvaluation = 4,
    additionalData = 5,
    orientations = 6,
    waitingArea = 7,
}